<template>
  <div ref="carousel"
       class="payment-account-cards-carousel">
    <div class="payment-account-cards-carousel__list">
      <PaymentAccountCardAkord class="payment-account-cards-carousel__item"/>
      <PaymentAccountCardSatchelPay class="payment-account-cards-carousel__item"/>
    </div>
  </div>
</template>

<script>
  import Swiper from "swiper";
  import PaymentAccountCardAkord from '@/components/payment/PaymentAccountCardAkord'
  import PaymentAccountCardSatchelPay from '@/components/payment/PaymentAccountCardSatchelPay'

  export default {
    name: 'PaymentAccountCardCarousel',
    components: {
      PaymentAccountCardAkord,
      PaymentAccountCardSatchelPay,
    },
    data() {
      return {
        swiper: null
      }
    },
    methods: {
      createSwiper() {
        const el = this.$refs['carousel']

        this.swiper = new Swiper(el, {
          wrapperClass: 'payment-account-cards-carousel__list',
          slideClass: 'payment-account-cards-carousel__item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          threshold: 2,
          on: {
            slideChange: () => {
              this.$emit('change', this.swiper.realIndex)
            }
          }
        })
      },
    },
    mounted() {
      setTimeout(() => {
        this.createSwiper()
      }, 100)
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    },
  }
</script>

<style lang="less">

</style>
